// extracted by mini-css-extract-plugin
export default {"container":"Ro-z","brandName":"So-z","productName":"To-z","productNamePdpEnhancements":"Uo-z","breakLongProductName":"Vo-z"};